var map = {
	"./Adidas-Logo.png": 9954,
	"./Mango-logo.png": 1930,
	"./Zara_Logo.svg": 4184,
	"./bershka-logo-png_seeklogo-669532.png": 3494,
	"./h-m-logo.svg": 2512,
	"./next.png": 6271,
	"./nike.svg": 3013,
	"./reserved-logo-vector.png": 8952,
	"./shein.jpg": 2633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3922;